import { useState } from 'react';
import { Button } from '../ui/button';
import { Textarea } from '../ui/textarea';
import { Copy, RefreshCw, Wand2 } from 'lucide-react';
import { toast } from 'sonner';

const SqlFormatterTool = () => {
  const [input, setInput] = useState('');

  const formatSql = (sql) => {
    if (!sql) return '';
    
    const keywords = [
      'SELECT', 'FROM', 'WHERE', 'AND', 'OR', 'JOIN', 'LEFT JOIN', 'RIGHT JOIN',
      'INNER JOIN', 'OUTER JOIN', 'ON', 'GROUP BY', 'ORDER BY', 'HAVING', 'LIMIT',
      'OFFSET', 'INSERT INTO', 'VALUES', 'UPDATE', 'SET', 'DELETE FROM', 'CREATE TABLE',
      'ALTER TABLE', 'DROP TABLE', 'CREATE INDEX', 'DROP INDEX', 'UNION', 'UNION ALL',
      'AS', 'DISTINCT', 'IN', 'NOT IN', 'LIKE', 'BETWEEN', 'IS NULL', 'IS NOT NULL',
      'EXISTS', 'CASE', 'WHEN', 'THEN', 'ELSE', 'END', 'ASC', 'DESC', 'WITH'
    ];

    let formatted = sql.trim();
    
    // Uppercase keywords
    keywords.forEach(keyword => {
      const regex = new RegExp(`\\b${keyword}\\b`, 'gi');
      formatted = formatted.replace(regex, keyword);
    });

    // Add newlines before major keywords
    const newlineKeywords = [
      'SELECT', 'FROM', 'WHERE', 'AND', 'OR', 'JOIN', 'LEFT JOIN', 'RIGHT JOIN',
      'INNER JOIN', 'GROUP BY', 'ORDER BY', 'HAVING', 'LIMIT', 'UNION', 'VALUES',
      'SET', 'ON'
    ];
    
    newlineKeywords.forEach(keyword => {
      const regex = new RegExp(`\\s+${keyword}\\b`, 'gi');
      formatted = formatted.replace(regex, `\n${keyword}`);
    });

    // Indent after SELECT, SET
    formatted = formatted.replace(/\bSELECT\b/g, 'SELECT\n  ');
    formatted = formatted.replace(/,\s*/g, ',\n  ');
    
    // Clean up multiple spaces
    formatted = formatted.replace(/  +/g, ' ');
    
    // Clean up multiple newlines
    formatted = formatted.replace(/\n\s*\n/g, '\n');

    return formatted.trim();
  };

  const output = formatSql(input);

  const copyOutput = () => {
    navigator.clipboard.writeText(output);
    toast.success('Formatted SQL copied!');
  };

  const minify = () => {
    const minified = input.replace(/\s+/g, ' ').trim();
    setInput(minified);
    toast.success('SQL minified!');
  };

  return (
    <div className="space-y-6" data-testid="sql-formatter-tool">
      <div className="grid md:grid-cols-2 gap-4">
        <div>
          <label className="text-sm text-muted-foreground mb-2 block">SQL Input</label>
          <Textarea
            placeholder="SELECT * FROM users WHERE id = 1"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            className="min-h-[300px] font-mono text-sm bg-muted/50"
          />
        </div>
        <div>
          <label className="text-sm text-muted-foreground mb-2 block">Formatted Output</label>
          <Textarea
            value={output}
            readOnly
            className="min-h-[300px] font-mono text-sm bg-muted/50"
            placeholder="Formatted SQL will appear here..."
          />
        </div>
      </div>

      <div className="flex gap-2">
        <Button onClick={copyOutput} disabled={!output}>
          <Copy className="w-4 h-4 mr-2" /> Copy Formatted
        </Button>
        <Button onClick={minify} variant="outline" disabled={!input}>
          <Wand2 className="w-4 h-4 mr-2" /> Minify
        </Button>
        <Button onClick={() => setInput('')} variant="outline">
          <RefreshCw className="w-4 h-4 mr-2" /> Clear
        </Button>
      </div>
    </div>
  );
};

export default SqlFormatterTool;
